
/* eslint-disable */

import CountryConditionItemMixin from '@ve/components/countryConditions/common/components/CountryConditionItem';
import trackingCountryConditions from '@/js/common/Domain/Service/tracking/trackingCountryConditions';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'CountryConditionItem',
})
export default class CountryConditionItem extends CountryConditionItemMixin {
    showDescription = false;

    handlerCountryConditionClick(): void {
        if (this.isLink) {
            this.sendAnalitics();
        }
        if (!this.isLink) {
            this.showDescription = !this.showDescription;
                if (this.showDescription) {
                    this.sendAnalitics();
                }
        }
    }

    sendAnalitics() {
        const conditionNameWidgetCountry: any = {
            1: 'whattoknow',
            2: 'covid-19',
            3: 'pcr',
        };
        const nameBanner: string = conditionNameWidgetCountry[this.note.priority];

        trackingCountryConditions(nameBanner);
    }
}
